var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOrbitCloud = function SvgOrbitCloud(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1282_9799)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1299 71.7718H73.0477C72.5276 71.7914 72.0067 71.7914 71.4863 71.7718H14.8179C14.8078 71.7718 14.7977 71.7717 14.7876 71.7714C14.749 71.7717 14.7104 71.7718 14.6718 71.7718C6.58025 71.7718 0.020752 64.9861 0.020752 56.6156C0.020752 48.245 6.58025 41.4593 14.6718 41.4593C15.5006 41.4593 16.3134 41.5305 17.1047 41.6673C18.5708 28.214 29.9688 17.7441 43.8122 17.7441C53.747 17.7441 62.4224 23.1365 67.0712 31.154C73.843 29.5037 81.3132 31.3424 86.6302 36.6594C94.7087 44.7378 94.7576 57.7867 86.7395 65.8048C83.0032 69.5411 78.1745 71.5257 73.2655 71.7625C73.2207 71.7687 73.1755 71.7718 73.1299 71.7718Z",
    fill: "url(#paint0_linear_1282_9799)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M86.6303 36.6588C78.5518 28.5803 65.503 28.5314 57.4849 36.5495C49.4668 44.5677 49.5157 57.6165 57.5941 65.6949C65.6726 73.7734 78.7214 73.8223 86.7395 65.8042C94.7576 57.7861 94.7087 44.7372 86.6303 36.6588Z",
    fill: "url(#paint1_linear_1282_9799)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.7759 45.9956C19.9223 40.142 10.4591 40.1146 4.63929 45.9344C-1.18054 51.7543 -1.15316 61.2175 4.70044 67.071C10.554 72.9246 20.0172 72.952 25.837 67.1322C31.6569 61.3124 31.6295 51.8492 25.7759 45.9956Z",
    fill: "url(#paint2_linear_1282_9799)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1779 18.5018C30.7577 2.72922 11.8023 -4.15172 4.62831 3.06266C-3.98044 11.6714 7.65956 37.3057 30.687 60.3028C53.7144 83.2999 79.3183 94.9399 87.9271 86.321C91.9687 82.2288 91.5343 74.297 87.4219 64.6172",
    stroke: "url(#paint3_angular_1282_9799)",
    strokeWidth: 0.505208,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.875 33.657C90.8573 20.0568 93.2318 8.31575 87.9271 3.06159C79.3083 -5.55727 53.674 6.09284 30.6769 29.1101C7.67983 52.1274 -4.02079 77.7112 4.62838 86.3199C11.7013 93.3928 30.2222 86.8049 49.3494 71.5072",
    stroke: "url(#paint4_angular_1282_9799)",
    strokeWidth: 0.505208,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4626 24.0802C89.7349 24.0802 90.7663 23.0487 90.7663 21.7764C90.7663 20.5041 89.7349 19.4727 88.4626 19.4727C87.1902 19.4727 86.1588 20.5041 86.1588 21.7764C86.1588 23.0487 87.1902 24.0802 88.4626 24.0802Z",
    fill: "url(#paint5_radial_1282_9799)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7539 91.7769C20.601 91.7769 22.0984 90.2795 22.0984 88.4324C22.0984 86.5853 20.601 85.0879 18.7539 85.0879C16.9068 85.0879 15.4094 86.5853 15.4094 88.4324C15.4094 90.2795 16.9068 91.7769 18.7539 91.7769Z",
    fill: "url(#paint6_radial_1282_9799)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M36.5272 40.0724C39.3453 40.0724 41.6298 37.7879 41.6298 34.9698C41.6298 32.1517 39.3453 29.8672 36.5272 29.8672C33.7091 29.8672 31.4246 32.1517 31.4246 34.9698C31.4246 37.7879 33.7091 40.0724 36.5272 40.0724Z",
    fill: "#0D47A1",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3536 6.99378C31.252 6.99378 31.9803 6.26545 31.9803 5.36701C31.9803 4.46856 31.252 3.74023 30.3536 3.74023C29.4551 3.74023 28.7268 4.46856 28.7268 5.36701C28.7268 6.26545 29.4551 6.99378 30.3536 6.99378Z",
    fill: "url(#paint7_radial_1282_9799)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7372 34.973C32.187 34.973 34.173 32.9871 34.173 30.5373C34.173 28.0875 32.187 26.1016 29.7372 26.1016C27.2875 26.1016 25.3015 28.0875 25.3015 30.5373C25.3015 32.9871 27.2875 34.973 29.7372 34.973Z",
    fill: "url(#paint8_radial_1282_9799)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4132 87.1183C62.3038 87.1183 64.6471 84.775 64.6471 81.8843C64.6471 78.9937 62.3038 76.6504 59.4132 76.6504C56.5225 76.6504 54.1792 78.9937 54.1792 81.8843C54.1792 84.775 56.5225 87.1183 59.4132 87.1183Z",
    fill: "url(#paint9_radial_1282_9799)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1282_9799",
    x1: 4.30789,
    y1: 45.897,
    x2: 22.6552,
    y2: 80.1431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1282_9799",
    x1: 67.7188,
    y1: 30.8491,
    x2: 67.8032,
    y2: 42.4683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2979FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C4FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1282_9799",
    x1: 12.0646,
    y1: 41.794,
    x2: 12.1331,
    y2: 50.2203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C4FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_angular_1282_9799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.4845 45.4907) rotate(43.1072) scale(53.9824 22.6489)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661245,
    stopColor: "#304FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712781,
    stopColor: "#304FFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879892,
    stopColor: "#304FFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980527,
    stopColor: "#304FFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_angular_1282_9799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.4896 45.499) rotate(134.653) scale(58.9451 24.0671)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#304FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653059,
    stopColor: "#304FFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77917,
    stopColor: "#304FFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#304FFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1282_9799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.6731 20.8895) rotate(26.565) scale(3.52028 3.52028)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304FFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1282_9799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.156 87.1448) rotate(26.565) scale(5.11058 5.11058)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304FFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1282_9799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.09 4.74074) rotate(26.565) scale(2.48581)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304FFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1282_9799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2917 28.8296) rotate(26.565) scale(6.77808 6.77808)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304FFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1282_9799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.3476 79.8694) rotate(26.565) scale(7.99783 7.99783)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304FFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1282_9799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.5239,
    height: 91.7357,
    fill: "white",
    transform: "translate(0.020874 0.03125)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOrbitCloud);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "orbit-cloud.59cfd7414b749a354f67faa523ac1e84.svg";